<div class=" rounded  flex items-center justify-center" [style.background]="backGroundColor" [style]="imageStyle">
  <h1 class="" [style]="textStyle">{{content|uppercase}}</h1>
</div>
